<div class="sync-progress-container" *ngIf="status()">
  
  <div *ngIf="error()" class="error-banner">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ error() }}</span>
  </div>

  <div class="status-header">
    <div class="status-badge" [class.status-badge--running]="status()?.isRunning" [class.status-badge--completed]="!status()?.isRunning">
      <i class="pi" [class.pi-spin]="status()?.isRunning" [class.pi-sync]="status()?.isRunning" [class.pi-check-circle]="!status()?.isRunning"></i>
      <span>{{ status()?.isRunning ? 'Synchronizacja w trakcie...' : 'Zakończono' }}</span>
    </div>
  </div>

  <div class="progress-section" *ngIf="status()?.isRunning || (status()?.processedUsersCount ?? 0) > 0">
    <div class="progress-info">
      <span class="progress-label">Postęp</span>
      <span class="progress-percentage">{{ status()?.progressPercentage }}%</span>
    </div>
    <p-progressBar 
      [value]="status()?.progressPercentage ?? 0" 
      [showValue]="false"
      styleClass="custom-progress">
    </p-progressBar>
    <div class="progress-details">
      <span>{{ status()?.processedUsersCount }} / {{ status()?.totalUsersToSync }} użytkowników</span>
      <span *ngIf="status()?.isRunning">{{ elapsedTime() }}</span>
    </div>
  </div>

  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-icon stat-icon--users">
        <i class="pi pi-users"></i>
      </div>
      <div class="stat-content">
        <div class="stat-label">Użytkownicy</div>
        <div class="stat-value">{{ status()?.processedUsersCount }} / {{ status()?.totalUsersToSync }}</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon stat-icon--questions">
        <i class="pi pi-plus-circle"></i>
      </div>
      <div class="stat-content">
        <div class="stat-label">Dodane pytania</div>
        <div class="stat-value">{{ status()?.addedQuestionsCount }}</div>
      </div>
    </div>

    <div class="stat-card" [class.stat-card--error]="(status()?.errorsCount ?? 0) > 0">
      <div class="stat-icon stat-icon--errors" [class.stat-icon--has-errors]="(status()?.errorsCount ?? 0) > 0">
        <i class="pi" [class.pi-exclamation-circle]="(status()?.errorsCount ?? 0) > 0" [class.pi-check-circle]="(status()?.errorsCount ?? 0) === 0"></i>
      </div>
      <div class="stat-content">
        <div class="stat-label">Błędy</div>
        <div class="stat-value" [class.stat-value--error]="(status()?.errorsCount ?? 0) > 0">{{ status()?.errorsCount }}</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon stat-icon--skipped">
        <i class="pi pi-minus-circle"></i>
      </div>
      <div class="stat-content">
        <div class="stat-label">Pominięci</div>
        <div class="stat-value">{{ status()?.skippedUsersCount }}</div>
      </div>
    </div>
  </div>

  <div class="timing-section" *ngIf="status()">
    <div class="timing-row" *ngIf="status()?.syncStartTime">
      <span class="timing-label">
        <i class="pi pi-calendar"></i>
        Rozpoczęto
      </span>
      <span class="timing-value">{{ status()?.syncStartTime | date:'yyyy-MM-dd HH:mm:ss' }}</span>
    </div>
    <div class="timing-row" *ngIf="status()?.lastUpdateTime">
      <span class="timing-label">
        <i class="pi pi-clock"></i>
        Ostatnia aktualizacja
      </span>
      <span class="timing-value">{{ status()?.lastUpdateTime | date:'yyyy-MM-dd HH:mm:ss' }}</span>
    </div>
    <div class="timing-row" *ngIf="status()?.syncStartTime">
      <span class="timing-label">
        <i class="pi pi-stopwatch"></i>
        Czas trwania
      </span>
      <span class="timing-value timing-value--mono">{{ elapsedTime() }}</span>
    </div>
    <div class="timing-row timing-row--with-action" *ngIf="status()?.lastProcessedUserExamGuid">
      <span class="timing-label">
        <i class="pi pi-bookmark"></i>
        Ostatni przetworzony GUID
      </span>
      <div class="timing-value-group">
        <span class="timing-value timing-value--mono timing-value--guid">{{ status()?.lastProcessedUserExamGuid }}</span>
        <p-button 
          icon="pi pi-copy"
          [text]="true"
          [rounded]="true"
          size="small"
          severity="secondary"
          pTooltip="Kopiuj do schowka"
          tooltipPosition="top"
          (onClick)="copyToClipboard(status()?.lastProcessedUserExamGuid!)" data-clarity-unmask="true">
        </p-button>
      </div>
    </div>
  </div>

  <div class="resume-section" *ngIf="status() && !status()?.isRunning">
    <div class="resume-header">
      <i class="pi pi-play-circle"></i>
      <span class="resume-title">Wznowienie synchronizacji</span>
    </div>
    <div class="resume-content">
      <!-- <p class="resume-description">
        Zostaw pole puste aby rozpocząć od początku, lub wklej GUID aby wznowić od określonego użytkownika.
      </p> -->
      <div class="resume-input-group">
        <input 
          type="text" 
          pInputText 
          [ngModel]="resumeFromGuid()"
          (ngModelChange)="resumeFromGuid.set($event)"
          placeholder="Wklej GUID użytkownika (opcjonalnie)"
          class="resume-input"
          [disabled]="loading()"
        />
        <p-button 
          *ngIf="status()?.lastProcessedUserExamGuid"
          label="Użyj ostatniego"
          icon="pi pi-arrow-up"
          [outlined]="true"
          size="small"
          [disabled]="loading()"
          (onClick)="useLastProcessedGuid()" data-clarity-unmask="true">
        </p-button>
        <p-button 
          *ngIf="resumeFromGuid()"
          icon="pi pi-times"
          [outlined]="true"
          [text]="true"
          size="small"
          [disabled]="loading()"
          (onClick)="clearGuid()" data-clarity-unmask="true">
        </p-button>
      </div>
    </div>
  </div>

  <!-- <div class="errors-section" *ngIf="status()?.errors && status()?.errors?.length! > 0">
    <div class="errors-header">
      <i class="pi pi-exclamation-triangle"></i>
      <span class="errors-title">Wystąpiły błędy ({{ status()?.errors?.length }})</span>
    </div>
    <ul class="errors-list">
      <li class="errors-item" *ngFor="let error of status()?.errors; index as index">
        <span class="error-index">#{{ index + 1 }}</span>
        <span class="error-text">{{ error }}</span>
      </li>
    </ul>
  </div> -->

  <div class="actions">
    <p-button 
      *ngIf="!status()?.isRunning"
      label="Rozpocznij synchronizację" 
      icon="pi pi-play"
      severity="success"
      [loading]="loading()"
      [disabled]="loading()"
      (onClick)="startSync()" data-clarity-unmask="true">
    </p-button>
    
    <p-button 
      *ngIf="status()?.isRunning"
      label="Zatrzymaj synchronizację" 
      icon="pi pi-stop"
      severity="danger"
      [outlined]="true"
      [loading]="loading()"
      [disabled]="loading()"
      (onClick)="stopSync()" data-clarity-unmask="true">
    </p-button>

    <p-button 
      label="Odśwież" 
      icon="pi pi-refresh"
      [outlined]="true"
      [disabled]="loading()"
      (onClick)="refreshStatus()" data-clarity-unmask="true">
    </p-button>
    
    <p-button 
      label="Zamknij" 
      icon="pi pi-times"
      [outlined]="true"
      [disabled]="loading()"
      (onClick)="closeDialog()" data-clarity-unmask="true">
    </p-button>
  </div>

</div>
